module.exports = __webpack_public_path__ + "static/media/cover-mobile.3f6b7735.jpg";